export { default } from './lib/Diagram';